"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearcherDatepickerMobile = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _ru = _interopRequireDefault(require("date-fns/locale/ru"));
var _SearcherFlexBadge = _interopRequireDefault(require("../SearcherFlexBadge"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _MobileDropdown = require("../MobileDropdown");
var _utils = require("./utils");
var _Calendar = require("../Calendar");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:

// Interface

// Utils and constants:

var SearcherDatepickerMobile = exports.SearcherDatepickerMobile = function SearcherDatepickerMobile(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    selectedDate = props.selectedDate,
    _props$onChangeDate = props.onChangeDate,
    onChangeDate = _props$onChangeDate === void 0 ? function () {
      return undefined;
    } : _props$onChangeDate,
    _props$currentDate = props.currentDate,
    currentDate = _props$currentDate === void 0 ? new Date() : _props$currentDate,
    _props$flexDates = props.flexDates,
    flexDates = _props$flexDates === void 0 ? false : _props$flexDates,
    _props$showFlexDates = props.showFlexDates,
    showFlexDates = _props$showFlexDates === void 0 ? false : _props$showFlexDates,
    _props$monthsShown = props.monthsShown,
    monthsShown = _props$monthsShown === void 0 ? 9 : _props$monthsShown,
    _props$onChangeFlexDa = props.onChangeFlexDate,
    onChangeFlexDate = _props$onChangeFlexDa === void 0 ? function () {
      return undefined;
    } : _props$onChangeFlexDa,
    CustomControl = props.CustomControl,
    CustomLabel = props.CustomLabel;
  var _useState = (0, _react.useState)(flexDates),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFlexDates = _useState2[0],
    setFlexDates = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var popupLabel = 'Дата вылета';

  // Хак, из-за анимации react-responsive-modal:
  var handleAnimationEnd = function handleAnimationEnd() {
    var element = document.querySelector('div:not(.react-datepicker__day--today).react-datepicker__day--selected');
    element === null || element === void 0 || element.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });
  };
  var handleChange = function handleChange(val) {
    onChangeDate(val);
    if (flexDates !== isFlexDates) onChangeFlexDate();
    setOpen(false);
  };
  var handleChangeFlex = function handleChangeFlex() {
    return setFlexDates(!isFlexDates);
  };
  var handleClickControl = function handleClickControl() {
    return setOpen(true);
  };
  var handleCancel = function handleCancel() {
    setFlexDates(flexDates);
    setOpen(false);
  };
  var Label = CustomControl ? CustomLabel : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, (0, _format["default"])(selectedDate, 'd MMMM', {
    locale: _ru["default"]
  })), flexDates && /*#__PURE__*/_react["default"].createElement(StyledSearcherFlexBadge, null));
  var FlexDaysCheckbox = showFlexDates && /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: isFlexDates,
    onChange: handleChangeFlex
  }, "\xB12 \u0434\u043D\u044F \u043E\u0442 \u0434\u0430\u0442\u044B \u0432\u044B\u043B\u0435\u0442\u0430");
  var CalendarComp = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Calendar.Calendar, {
    calendarClassName: className,
    startDate: (0, _addDays["default"])(currentDate, 1),
    selected: new Date(currentDate),
    onChange: handleChange,
    minDate: (0, _utils.getMinDate)(currentDate),
    maxDate: (0, _utils.getMaxDate)(currentDate),
    highlightDates: (0, _utils.highlightCurrentDate)(selectedDate),
    monthsShown: monthsShown,
    focusSelectedMonth: false,
    isMobile: true
  }), FlexDaysCheckbox);
  return /*#__PURE__*/_react["default"].createElement(StyledMobileDropdown, {
    open: open,
    onCancel: handleCancel,
    onAnimationEnd: handleAnimationEnd,
    onControlClick: handleClickControl,
    popupLabel: popupLabel,
    dropdownLabel: Label,
    submitButtonText: "",
    CustomDropdownLabel: CustomControl,
    fullControl: true
  }, CalendarComp);
};
var StyledSearcherFlexBadge = (0, _styledComponents["default"])(_SearcherFlexBadge["default"]).withConfig({
  displayName: "SearcherDatepickermobile__StyledSearcherFlexBadge",
  componentId: "sc-77gpp6-0"
})(["margin-left:2px;"]);
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "SearcherDatepickermobile__StyledCheckbox",
  componentId: "sc-77gpp6-1"
})(["height:50px;justify-content:center;align-items:center;user-select:none;left:0;right:0;bottom:0;position:fixed;background:#fff;white-space:nowrap;&:after{height:50px;bottom:50px;content:'';width:100%;position:fixed;background:linear-gradient( rgba(255,255,255,0.6) 0%,rgb(255,255,255) 100% );}input{outline:0;}"]);
var StyledMobileDropdown = (0, _styledComponents["default"])(_MobileDropdown.MobileDropdown).withConfig({
  displayName: "SearcherDatepickermobile__StyledMobileDropdown",
  componentId: "sc-77gpp6-2"
})(["& .react-datepicker{flex-direction:column;width:100%;margin-bottom:100px;}.react-datepicker__month-container{padding:0;}.react-datepicker__navigation{display:none;}.react-datepicker__day--outside-month{background:#fff !important;}"]);